import { useRef } from "react";
import CustomHook from "./CustomHook";
import ym from "react-yandex-metrika";
import { useNavigate } from "react-router";

function Home() {
  const scrollTab = useRef();
  const navigate = useNavigate();
  CustomHook(scrollTab);

  const handleClickResume = () => {
    ym("reachGoal", "click_button_resume_download");
  };

  const handleClickWrite = () => {
    ym("reachGoal", "click_button_write_me");
  };

  const handleDownload = (event) => {
    event.preventDefault();

    handleClickResume();

    const fileUrl = `${process.env.PUBLIC_URL}/CVDmitry.pdf`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "CVDmitry.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => navigate("/cv"), 300);
  };

  return (
    <section ref={scrollTab} id="heading" className="home">
      <div className="content">
        <div className="name">
          Привет, Я <span>Дмитрий Сахаров</span>
        </div>
        <div className="des">
          Frontend-разработчик с 4-летним опытом. Создаю и дорабатываю
          интерфейсы, которые решают задачи бизнеса: ускоряют сайты, увеличивают
          конверсию и упрощают управление контентом. Работал с госпроектами,
          строительными компаниями и малым бизнесом. Глубоко владею
          React/Vue-экосистемами. Беру полную ответственность за техническую
          часть: от оценки задачи до запуска и поддержки.
        </div>

        <div class="home-line-btns">
          <a
            onClick={handleClickWrite}
            href="https://t.me/DmitriyWork201"
            target="_blank"
            rel="noopener noreferrer"
            className="animation active "
          >
            Написать мне
          </a>
          <a
            onClick={handleDownload}
            href="!#"
            target="_blank"
            rel="noopener noreferrer"
            className="animation active "
          >
            Скачать резюме
          </a>
        </div>
      </div>
      <div className="avatar">
        <div className="card">
          <img src="/me.jpg" alt="" fetchpriority="high" />
          <div className="info">
            <div>Frontend Developer</div>
            <div style={{ textAlign: "right" }}>4 года разработки</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
